import { ComponentRef, Injectable } from '@angular/core';
import { ConfirmationComponent } from '@components/confirmation/confirmation.component';
import { Observable, Subscriber } from 'rxjs';

interface Confirmation {
  Title: string;
  Body: string;
  ConfirmText: string;
  RejectText: string;
  OnConfirm?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  public Confirmations = new Observable<Confirmation>(subscriber => {
    this.ConfirmationsSubscriber = subscriber;
  });
  public NewConfirmationComponentCreated = new Observable<ComponentRef<ConfirmationComponent>>(subscriber => {
    this.NewConfirmationComponentCreatedSubscriber = subscriber;
  });
  private ConfirmationsSubscriber!: Subscriber<Confirmation>;
  public NewConfirmationComponentCreatedSubscriber!: Subscriber<ComponentRef<ConfirmationComponent>>;

  /**
   * Creates a new confirmation and returns the Angular view reference
   */
  public async NewConfirmation(
    title: string, 
    body: string, 
    confirmText: string | undefined = undefined, 
    rejectText: string | undefined = undefined, 
    onConfirm: (() => void) | undefined = undefined
  ): Promise<ComponentRef<ConfirmationComponent>> {
    const p = new Promise<ComponentRef<ConfirmationComponent>>((resolve) => {
      const subscription = this.NewConfirmationComponentCreated.subscribe({
        next: componentRef => {
          subscription.unsubscribe();
          return resolve(componentRef);
        }
      });
    });
    this.ConfirmationsSubscriber.next({
      Title: title,
      Body: body,
      ConfirmText: confirmText ?? "Confirm",
      RejectText: rejectText ?? "Cancel",
      OnConfirm: onConfirm
    });

    return await p;
  }
}
